import { createSelector } from 'reselect';
import { RootState } from '../store';

const getProduct = (state: RootState) => state.product;

// @ts-expect-error Need to convert product reduce to typescript
export const getDefaultGiftCard = createSelector(getProduct, (product) => product.defaultGiftCard);
